import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React from "react";
import { usePromiseTracker } from "react-promise-tracker";
const AreaLoader = ({ area, customStyle, loadingText = ``, className = "", wrapperClassName = "", isLandingPage = false, }) => {
    const { promiseInProgress } = usePromiseTracker({ area });
    if (!promiseInProgress)
        return React.createElement(React.Fragment, null);
    // return <>{loadingText || <Skeleton.Button active style={customStyle} />}</>;
    const neonStyle = isLandingPage
        ? {
            color: "#59afff",
        }
        : {
            color: (customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) || "#1890ff",
        };
    return (React.createElement(React.Fragment, null, loadingText || (React.createElement(Spin, { className: className, wrapperClassName: wrapperClassName, indicator: React.createElement(LoadingOutlined, { style: neonStyle, spin: true }) }))));
};
export default AreaLoader;
